const GridCardBHKData = {
  min: 2,
  max: 3,
  label: "2 - 3 BHK",
  enableLabel: false,
};

export default GridCardBHKData;
